import {
    getData,
    postData,
    patchData,
    deleteData
} from './Services'

export const getMedidasPanel = async (searchTerm, page, perPage) => {
    let queryParams = [];
    if (searchTerm) {
        queryParams.push(`medida_descripcion=${encodeURIComponent(searchTerm || '')}`);
    }
    if (page) {
        queryParams.push(`page=${encodeURIComponent(page || 1)}`);
    }
    if (perPage) {
        queryParams.push(`perPage=${encodeURIComponent(perPage || 10)}`);
    }
    const queryString = queryParams.length > 0 ? `?&${queryParams.join('&')}` : '';
    return await getData("/medidas", queryString);
}

export const getMedidaById = async (id) => {
    const res = await getData(`/medidas/${id}`)
    return res
}

export const postMedida = async (body) => {
    const res = await postData('/medidas', body)
    return res
}

export const patchMedida = async (id, body) => {
    const res = await patchData(`/medidas/${id}`, body)
    return res
}

export const deleteMedida = async (id) => {
    const res = await deleteData(`/medidas/${id}`)
    return res
}